module.exports = __webpack_public_path__ + "img/default-profile.16069ca8.svg";